export const questions_en = [
  {
    id: '43c98ce8-a07a-4dc2-80f6-c1b2a2485f06',
    text: 'I worry about things',
    keyed: 'plus',
    domain: 'N',
    facet: 1
  },
  {
    id: 'd50a597f-632b-4f7b-89e6-6d85b50fd1c9',
    text: 'I make friends easily',
    keyed: 'plus',
    domain: 'E',
    facet: 1
  },
  {
    id: '888dd864-7449-4e96-8d5c-7a439603ea91',
    text: 'I have a vivid imagination',
    keyed: 'plus',
    domain: 'O',
    facet: 1
  },
  {
    id: 'ce2fbbf8-7a97-4199-bda5-117e4ecdf3b6',
    text: 'I trust others',
    keyed: 'plus',
    domain: 'A',
    facet: 1
  },
  {
    id: 'c7f53c3c-2e77-432f-bb71-7470b67d3aa9',
    text: 'I complete tasks successfully',
    keyed: 'plus',
    domain: 'C',
    facet: 1
  },
  {
    id: '48ad12ce-470e-4339-90ac-ea8c43a0103e',
    text: 'I get angry easily',
    keyed: 'plus',
    domain: 'N',
    facet: 2
  },
  {
    id: '458f3957-2359-4077-ade1-34525d633063',
    text: 'I love large parties',
    keyed: 'plus',
    domain: 'E',
    facet: 2
  },
  {
    id: '58d571e5-d725-4cf8-a438-32c16ee28eb6',
    text: 'I believe in the importance of art',
    keyed: 'plus',
    domain: 'O',
    facet: 2
  },
  {
    id: '0cf79e27-e702-45c2-9471-04ac96b58e0e',
    text: 'I use others for my own ends',
    keyed: 'minus',
    domain: 'A',
    facet: 2
  },
  {
    id: 'cda1ca17-b599-4561-a6cd-ff9d36062d27',
    text: 'I like to tidy up',
    keyed: 'plus',
    domain: 'C',
    facet: 2
  },
  {
    id: '5e8550d7-b8ef-4905-950a-f81d735d39e2',
    text: 'I often feel blue',
    keyed: 'plus',
    domain: 'N',
    facet: 3
  },
  {
    id: '8af754f2-68e9-48f3-8c5d-2e6633d4472c',
    text: 'I take charge',
    keyed: 'plus',
    domain: 'E',
    facet: 3
  },
  {
    id: '0727def6-3d18-4221-bf38-86b58f9f3eed',
    text: 'I experience my emotions intensely',
    keyed: 'plus',
    domain: 'O',
    facet: 3
  },
  {
    id: 'ccf3a5c8-fb50-4bd4-8e7a-22af3d657279',
    text: 'I love to help others',
    keyed: 'plus',
    domain: 'A',
    facet: 3
  },
  {
    id: '73d84e5d-cbf5-47f0-b8cb-4d2159a52e32',
    text: 'I keep my promises',
    keyed: 'plus',
    domain: 'C',
    facet: 3
  },
  {
    id: 'b2d9ef74-73f5-4ea8-b00c-7aaca15937df',
    text: 'I find it difficult to approach others',
    keyed: 'plus',
    domain: 'N',
    facet: 4
  },
  {
    id: '48a761ef-438e-409b-ae59-ea2ce8f84414',
    text: 'I am always busy',
    keyed: 'plus',
    domain: 'E',
    facet: 4
  },
  {
    id: 'cae55842-8957-4e3b-83b3-ceff98fb9dcf',
    text: 'I prefer variety to routine',
    keyed: 'plus',
    domain: 'O',
    facet: 4
  },
  {
    id: 'e2028ad3-b128-4f76-be57-398bfe2aff22',
    text: 'I love a good fight',
    keyed: 'minus',
    domain: 'A',
    facet: 4
  },
  {
    id: 'b7fc949b-02b6-4cb9-a3e2-dbb3d824b55f',
    text: 'I work hard',
    keyed: 'plus',
    domain: 'C',
    facet: 4
  },
  {
    id: '481efd08-c810-43b1-a952-f8ac9052f96b',
    text: 'I go on binges',
    keyed: 'plus',
    domain: 'N',
    facet: 5
  },
  {
    id: '987efee2-899f-4a65-b9b5-1589ef0460d7',
    text: 'I love excitement',
    keyed: 'plus',
    domain: 'E',
    facet: 5
  },
  {
    id: 'e1e804c7-4a1d-498f-8610-f95147af9d1d',
    text: 'I love to read challenging material',
    keyed: 'plus',
    domain: 'O',
    facet: 5
  },
  {
    id: '71029381-3908-4c68-91e1-e41fb45542a2',
    text: 'I believe that I am better than others',
    keyed: 'minus',
    domain: 'A',
    facet: 5
  },
  {
    id: 'f6076eea-56ae-4b46-97f1-5f94a7676c96',
    text: 'I am always prepared',
    keyed: 'plus',
    domain: 'C',
    facet: 5
  },
  {
    id: '2f519935-92e8-48ad-9746-4a0f8b38466a',
    text: 'I panic easily',
    keyed: 'plus',
    domain: 'N',
    facet: 6
  },
  {
    id: '899c3f66-51d0-46ea-963a-6fc36d3b3cb9',
    text: 'I radiate joy',
    keyed: 'plus',
    domain: 'E',
    facet: 6
  },
  {
    id: '79186f48-e7fa-4df4-b74b-b0627ee244e1',
    text: 'I tend to vote for liberal political candidates',
    keyed: 'plus',
    domain: 'O',
    facet: 6
  },
  {
    id: 'fd50e1ca-d9e0-4037-a7a1-a191d4db2d96',
    text: 'I sympathize with the homeless',
    keyed: 'plus',
    domain: 'A',
    facet: 6
  },
  {
    id: 'bd9eec0a-b68b-472c-8803-7db29c308cdb',
    text: 'I jump into things without thinking',
    keyed: 'minus',
    domain: 'C',
    facet: 6
  },
  {
    id: '7f92ab2c-265c-4b84-8c74-09f9bb9d41a7',
    text: 'I fear for the worst',
    keyed: 'plus',
    domain: 'N',
    facet: 1
  },
  {
    id: 'af55f014-788c-4b6e-92c4-b2b59dc8a28d',
    text: 'I feel comfortable around people',
    keyed: 'plus',
    domain: 'E',
    facet: 1
  },
  {
    id: '08ff6dca-02a5-4aeb-aaa4-2ecf2526f143',
    text: 'I enjoy wild flights of fantasy',
    keyed: 'plus',
    domain: 'O',
    facet: 1
  },
  {
    id: '6f66cdc0-9044-457b-b40d-501ecae15ee7',
    text: 'I believe that others have good intentions',
    keyed: 'plus',
    domain: 'A',
    facet: 1
  },
  {
    id: 'f110fc66-2e9e-413c-920b-19f05e63d7ac',
    text: 'I excel in what I do',
    keyed: 'plus',
    domain: 'C',
    facet: 1
  },
  {
    id: '7dab2a37-8635-4fc7-86b7-0abf13c183c9',
    text: 'I get irritated easily',
    keyed: 'plus',
    domain: 'N',
    facet: 2
  },
  {
    id: '28ab59a0-e7cd-4fce-94e3-bba2ecc023b6',
    text: 'I talk to a lot of different people at parties',
    keyed: 'plus',
    domain: 'E',
    facet: 2
  },
  {
    id: 'b5919f2f-cded-4745-a9ce-c02703cee807',
    text: 'I see beauty in things that others might not notice',
    keyed: 'plus',
    domain: 'O',
    facet: 2
  },
  {
    id: '5a5fa975-d024-4ac8-8845-2823f957c21b',
    text: 'I cheat to get ahead',
    keyed: 'minus',
    domain: 'A',
    facet: 2
  },
  {
    id: 'adf33f9f-45bd-43e3-af25-4c491176d97f',
    text: 'I often forget to put things back in their proper place',
    keyed: 'minus',
    domain: 'C',
    facet: 2
  },
  {
    id: 'f0a14e16-d726-47e9-a2c1-647fd3d7d52e',
    text: 'I dislike myself',
    keyed: 'plus',
    domain: 'N',
    facet: 3
  },
  {
    id: '0b38e3d3-c15c-454c-b034-f4eb7ae1580a',
    text: 'I try to lead others',
    keyed: 'plus',
    domain: 'E',
    facet: 3
  },
  {
    id: '5631b856-ff34-4f76-a0cd-edc7104c3bfa',
    text: "I feel others' emotions",
    keyed: 'plus',
    domain: 'O',
    facet: 3
  },
  {
    id: 'ada867af-4db1-4e3d-a604-2b695c1806e5',
    text: 'I am concerned about others',
    keyed: 'plus',
    domain: 'A',
    facet: 3
  },
  {
    id: 'c55e3958-00c4-4fc3-9118-47d8f31bfde1',
    text: 'I tell the truth',
    keyed: 'plus',
    domain: 'C',
    facet: 3
  },
  {
    id: 'acd8fadc-5399-4a67-b5ff-9d1ada049c01',
    text: 'I am afraid to draw attention to myself',
    keyed: 'plus',
    domain: 'N',
    facet: 4
  },
  {
    id: 'd07b6c67-0d02-4948-a997-bb84ac234cd8',
    text: 'I am always on the go',
    keyed: 'plus',
    domain: 'E',
    facet: 4
  },
  {
    id: '33b81fd0-7e32-4cd8-a13a-d5f5f754f998',
    text: 'I prefer to stick with things that I know',
    keyed: 'minus',
    domain: 'O',
    facet: 4
  },
  {
    id: 'd9a9a180-29c9-4ec5-8621-2256d411def7',
    text: 'I yell at people',
    keyed: 'minus',
    domain: 'A',
    facet: 4
  },
  {
    id: 'f12c3d9d-1d12-4aa6-ad2e-009cd0651cbb',
    text: "I do more than what's expected of me",
    keyed: 'plus',
    domain: 'C',
    facet: 4
  },
  {
    id: '9891b7ba-a494-4307-aafe-301d8db506c6',
    text: 'I rarely overindulge',
    keyed: 'minus',
    domain: 'N',
    facet: 5
  },
  {
    id: 'f1675af6-88bf-4376-a946-0281e762b39c',
    text: 'I seek adventure',
    keyed: 'plus',
    domain: 'E',
    facet: 5
  },
  {
    id: '95a3f20c-f933-4d19-a2c1-a7dbdf63c562',
    text: 'I avoid philosophical discussions',
    keyed: 'minus',
    domain: 'O',
    facet: 5
  },
  {
    id: '7df44711-4cd4-4b05-8830-73fcc3ebdab5',
    text: 'I think highly of myself',
    keyed: 'minus',
    domain: 'A',
    facet: 5
  },
  {
    id: '9d3cb5c7-955c-43a4-b6c7-b07ed01dcbd9',
    text: 'I carry out my plans',
    keyed: 'plus',
    domain: 'C',
    facet: 5
  },
  {
    id: '13c58810-3864-42ba-aa87-d4166f858756',
    text: 'I become overwhelmed by events',
    keyed: 'plus',
    domain: 'N',
    facet: 6
  },
  {
    id: '961376e0-16a1-4c14-b059-789e63d11b63',
    text: 'I have a lot of fun',
    keyed: 'plus',
    domain: 'E',
    facet: 6
  },
  {
    id: 'f08e1b27-3673-4898-9cae-896482d0d9f9',
    text: 'I believe that there is no absolute right and wrong',
    keyed: 'plus',
    domain: 'O',
    facet: 6
  },
  {
    id: 'c2038c12-7a37-47a8-9983-831bd6692aab',
    text: 'I feel sympathy for those who are worse off than myself',
    keyed: 'plus',
    domain: 'A',
    facet: 6
  },
  {
    id: '956f3e17-ff17-4af5-a52f-9222b8968106',
    text: 'I make rash decisions',
    keyed: 'minus',
    domain: 'C',
    facet: 6
  },
  {
    id: '4d81238b-5407-47d4-88e5-dc0e38aa14f5',
    text: 'I am afraid of many things',
    keyed: 'plus',
    domain: 'N',
    facet: 1
  },
  {
    id: '9f9166f0-fa94-4c14-a91d-3eecd8395794',
    text: 'I avoid contacts with others',
    keyed: 'minus',
    domain: 'E',
    facet: 1
  },
  {
    id: '23a1034f-fab7-4887-a66e-5ef4eaafb25e',
    text: 'I love to daydream',
    keyed: 'plus',
    domain: 'O',
    facet: 1
  },
  {
    id: 'c63e6121-c3ed-40cc-abc2-c1e6ea1e0858',
    text: 'I trust what people say',
    keyed: 'plus',
    domain: 'A',
    facet: 1
  },
  {
    id: '02ee1930-36a7-4caa-b10c-c93efb682a44',
    text: 'I handle tasks smoothly',
    keyed: 'plus',
    domain: 'C',
    facet: 1
  },
  {
    id: 'da8e6ed1-2296-4c58-8fdb-66f2f591989b',
    text: 'I lose my temper',
    keyed: 'plus',
    domain: 'N',
    facet: 2
  },
  {
    id: '03c10b30-b88f-4c63-8acc-71251ca24615',
    text: 'I prefer to be alone',
    keyed: 'minus',
    domain: 'E',
    facet: 2
  },
  {
    id: '751a04bc-5adf-485a-8ea4-4308406ae85b',
    text: 'I do not like poetry',
    keyed: 'minus',
    domain: 'O',
    facet: 2
  },
  {
    id: '982e83c2-d34e-48da-9c71-78494ab05c85',
    text: 'I take advantage of others',
    keyed: 'minus',
    domain: 'A',
    facet: 2
  },
  {
    id: 'f4891687-0ff0-47af-a4f6-d1202c8f6676',
    text: 'I leave a mess in my room',
    keyed: 'minus',
    domain: 'C',
    facet: 2
  },
  {
    id: '743d8973-1de1-4485-91b4-8a5cf63e7d44',
    text: 'I am often down in the dumps',
    keyed: 'plus',
    domain: 'N',
    facet: 3
  },
  {
    id: '2452f034-8273-4f71-9122-a40f5ead31ba',
    text: 'I take control of things',
    keyed: 'plus',
    domain: 'E',
    facet: 3
  },
  {
    id: '2a300001-6e05-4c79-b8b5-2ccae4c3d463',
    text: 'I rarely notice my emotional reactions',
    keyed: 'minus',
    domain: 'O',
    facet: 3
  },
  {
    id: 'cd54bd76-ca9c-4030-b325-bb8d896bcb3f',
    text: 'I am indifferent to the feelings of others',
    keyed: 'minus',
    domain: 'A',
    facet: 3
  },
  {
    id: '4e6e3a34-176f-4e6e-8730-1341611f972b',
    text: 'I break rules',
    keyed: 'minus',
    domain: 'C',
    facet: 3
  },
  {
    id: '20062533-a33d-4c1e-9cd9-bff868015b3f',
    text: 'I only feel comfortable with friends',
    keyed: 'plus',
    domain: 'N',
    facet: 4
  },
  {
    id: 'b2a077d5-1fe0-4b06-ab63-35455e001e54',
    text: 'I do a lot in my spare time',
    keyed: 'plus',
    domain: 'E',
    facet: 4
  },
  {
    id: '0d2e65ab-95d9-482f-beb4-3239a3a4944a',
    text: 'I dislike changes',
    keyed: 'minus',
    domain: 'O',
    facet: 4
  },
  {
    id: '0de0f900-cede-4538-9c00-5da4f830b028',
    text: 'I insult people',
    keyed: 'minus',
    domain: 'A',
    facet: 4
  },
  {
    id: 'a9c97d6b-6721-4150-8d84-64ef3082f164',
    text: 'I do just enough work to get by',
    keyed: 'minus',
    domain: 'C',
    facet: 4
  },
  {
    id: '9f2e7f90-0ca5-4ed0-9fe5-e060238a9b5e',
    text: 'I easily resist temptations',
    keyed: 'minus',
    domain: 'N',
    facet: 5
  },
  {
    id: '7dd6cf2d-5c14-48c2-8ae5-633a7a596c71',
    text: 'I enjoy being reckless',
    keyed: 'plus',
    domain: 'E',
    facet: 5
  },
  {
    id: 'fecc35f7-681e-4889-a404-4a973a3dfef0',
    text: 'I have difficulty understanding abstract ideas',
    keyed: 'minus',
    domain: 'O',
    facet: 5
  },
  {
    id: '1d686958-6fe7-432f-85e6-186b99e4e232',
    text: 'I have a high opinion of myself',
    keyed: 'minus',
    domain: 'A',
    facet: 5
  },
  {
    id: 'c7db0ed8-df7d-49bf-942f-59e46ef743c4',
    text: 'I waste my time',
    keyed: 'minus',
    domain: 'C',
    facet: 5
  },
  {
    id: 'b7e0e393-9b21-4e0d-adf3-8f28fb5b9d87',
    text: "I feel that I'm unable to deal with things",
    keyed: 'plus',
    domain: 'N',
    facet: 6
  },
  {
    id: '79d956e8-1118-402a-a0e2-9380af18243e',
    text: 'I love life',
    keyed: 'plus',
    domain: 'E',
    facet: 6
  },
  {
    id: '96ba77b2-1a44-4dfd-95f9-ae4d1f714460',
    text: 'I tend to vote for conservative political candidates',
    keyed: 'minus',
    domain: 'O',
    facet: 6
  },
  {
    id: '77f54ab4-0fba-4efb-8700-066c7490eb87',
    text: "I am not interested in other people's problems",
    keyed: 'minus',
    domain: 'A',
    facet: 6
  },
  {
    id: 'a354cf7c-8d11-46ac-acc5-da90d2048637',
    text: 'I rush into things',
    keyed: 'minus',
    domain: 'C',
    facet: 6
  },
  {
    id: '43b03992-3f32-4ed1-a6f8-5d6d3e7ed246',
    text: 'I get stressed out easily',
    keyed: 'plus',
    domain: 'N',
    facet: 1
  },
  {
    id: '41702602-08e4-4e2b-9a19-291d9efc581a',
    text: 'I keep others at a distance',
    keyed: 'minus',
    domain: 'E',
    facet: 1
  },
  {
    id: '935a7413-abac-4f54-9169-d1fbd39da752',
    text: 'I like to get lost in thought',
    keyed: 'plus',
    domain: 'O',
    facet: 1
  },
  {
    id: '432dbde8-8756-4ff0-80d5-f47018235139',
    text: 'I distrust people',
    keyed: 'minus',
    domain: 'A',
    facet: 1
  },
  {
    id: '5727c93f-317b-4af1-a686-77fc9fbc5033',
    text: 'I know how to get things done',
    keyed: 'plus',
    domain: 'C',
    facet: 1
  },
  {
    id: 'd32bd062-4eb2-401b-99b2-e7afea39ca9b',
    text: 'I am not easily annoyed',
    keyed: 'minus',
    domain: 'N',
    facet: 2
  },
  {
    id: '9a47184f-6046-4e68-a61b-3d9b357b86ea',
    text: 'I avoid crowds',
    keyed: 'minus',
    domain: 'E',
    facet: 2
  },
  {
    id: '87c5b27e-59a8-4c48-8ba8-f5413d735693',
    text: 'I do not enjoy going to art museums',
    keyed: 'minus',
    domain: 'O',
    facet: 2
  },
  {
    id: '11b20adb-abed-4363-894c-3dd823ae0540',
    text: "I obstruct others' plans",
    keyed: 'minus',
    domain: 'A',
    facet: 2
  },
  {
    id: '50418d86-712c-45d9-adc4-ea0231c93cf5',
    text: 'I leave my belongings around',
    keyed: 'minus',
    domain: 'C',
    facet: 2
  },
  {
    id: 'f40e421f-6c24-4be2-bd9f-28d33358d8c6',
    text: 'I feel comfortable with myself',
    keyed: 'minus',
    domain: 'N',
    facet: 3
  },
  {
    id: '8791f37b-686f-47c3-9db7-74c009951321',
    text: 'I wait for others to lead the way',
    keyed: 'minus',
    domain: 'E',
    facet: 3
  },
  {
    id: '4fd25155-9cc2-4cd6-8852-3e0ca2d5e95d',
    text: "I don't understand people who get emotional",
    keyed: 'minus',
    domain: 'O',
    facet: 3
  },
  {
    id: 'b68af20d-24f9-4c27-85cc-fe0858994888',
    text: 'I take no time for others',
    keyed: 'minus',
    domain: 'A',
    facet: 3
  },
  {
    id: '54423933-0ebb-44a7-bdd9-2a9b100c70f2',
    text: 'I break my promises',
    keyed: 'minus',
    domain: 'C',
    facet: 3
  },
  {
    id: '7317848c-3e1b-422f-bb16-02efc504f677',
    text: 'I am not bothered by difficult social situations',
    keyed: 'minus',
    domain: 'N',
    facet: 4
  },
  {
    id: '7d93e1ca-46e8-4a30-9623-42a80c9b420c',
    text: 'I like to take it easy',
    keyed: 'minus',
    domain: 'E',
    facet: 4
  },
  {
    id: 'a7f43928-8982-4ed5-8656-7a80346fe979',
    text: 'I am attached to conventional ways',
    keyed: 'minus',
    domain: 'O',
    facet: 4
  },
  {
    id: '17910a55-a64a-4ed0-8b46-293e2fa2fe03',
    text: 'I get back at others',
    keyed: 'minus',
    domain: 'A',
    facet: 4
  },
  {
    id: '3890bb43-2695-4b8d-b289-ee10d11cc884',
    text: 'I put little time and effort into my work',
    keyed: 'minus',
    domain: 'C',
    facet: 4
  },
  {
    id: '49a85680-53aa-4208-86b5-dccc7a6f8e37',
    text: 'I am able to control my cravings',
    keyed: 'minus',
    domain: 'N',
    facet: 5
  },
  {
    id: '10f90fa9-649c-4631-ac4c-3dd3f751597d',
    text: 'I act wild and crazy',
    keyed: 'plus',
    domain: 'E',
    facet: 5
  },
  {
    id: 'b86de003-c3c4-4cc8-9385-5ac8a0142c34',
    text: 'I am not interested in theoretical discussions',
    keyed: 'minus',
    domain: 'O',
    facet: 5
  },
  {
    id: '80c1d149-7050-481a-9953-aefb441642e7',
    text: 'I boast about my virtues',
    keyed: 'minus',
    domain: 'A',
    facet: 5
  },
  {
    id: '51403620-968c-42fa-a772-65ba5ad8396f',
    text: 'I have difficulty starting tasks',
    keyed: 'minus',
    domain: 'C',
    facet: 5
  },
  {
    id: '88a3c2fe-3aa4-4f46-9322-da656332268a',
    text: 'I remain calm under pressure',
    keyed: 'minus',
    domain: 'N',
    facet: 6
  },
  {
    id: 'e7b31bdc-5f6b-40ec-ba91-f5919b0f170e',
    text: 'I look at the bright side of life',
    keyed: 'plus',
    domain: 'E',
    facet: 6
  },
  {
    id: '580b08d1-3c94-46e9-9d07-d6d80c698127',
    text: 'I believe that we should be tough on crime',
    keyed: 'minus',
    domain: 'O',
    facet: 6
  },
  {
    id: '48bee420-60c0-45cd-be43-3893dbc1969a',
    text: 'I try not to think about the needy',
    keyed: 'minus',
    domain: 'A',
    facet: 6
  },
  {
    id: 'ea3327ea-3529-4be4-8e2d-2174731ae4d7',
    text: 'I act without thinking',
    keyed: 'minus',
    domain: 'C',
    facet: 6
  }
]

export const choices_en = {
  plus: [
    {
      text: 'Very Inaccurate',
      score: 1,
      color: 1
    },
    {
      text: 'Moderately Inaccurate',
      score: 2,
      color: 2
    },
    {
      text: 'Neither Accurate Nor Inaccurate',
      score: 3,
      color: 3
    },
    {
      text: 'Moderately Accurate',
      score: 4,
      color: 4
    },
    {
      text: 'Very Accurate',
      score: 5,
      color: 5
    }
  ],
  minus: [
    {
      text: 'Very Inaccurate',
      score: 5,
      color: 1
    },
    {
      text: 'Moderately Inaccurate',
      score: 4,
      color: 2
    },
    {
      text: 'Neither Accurate Nor Inaccurate',
      score: 3,
      color: 3
    },
    {
      text: 'Moderately Accurate',
      score: 2,
      color: 4
    },
    {
      text: 'Very Accurate',
      score: 1,
      color: 5
    }
  ]
}


export const questions_sv = [
  {
    id: '43c98ce8-a07a-4dc2-80f6-c1b2a2485f06',
    text: 'Jag oroar mig över saker',
    keyed: 'plus',
    domain: 'N',
    facet: 1
  },
  {
    id: 'd50a597f-632b-4f7b-89e6-6d85b50fd1c9',
    text: 'Jag har lätt för att få vänner',
    keyed: 'plus',
    domain: 'E',
    facet: 1
  },
  {
    id: '888dd864-7449-4e96-8d5c-7a439603ea91',
    text: 'Jag har en livlig fantasi',
    keyed: 'plus',
    domain: 'O',
    facet: 1
  },
  {
    id: 'ce2fbbf8-7a97-4199-bda5-117e4ecdf3b6',
    text: 'Jag litar på andra',
    keyed: 'plus',
    domain: 'A',
    facet: 1
  },
  {
    id: 'c7f53c3c-2e77-432f-bb71-7470b67d3aa9',
    text: 'Jag slutför mina uppgifter',
    keyed: 'plus',
    domain: 'C',
    facet: 1
  },
  {
    id: '48ad12ce-470e-4339-90ac-ea8c43a0103e',
    text: 'Jag blir lätt arg',
    keyed: 'plus',
    domain: 'N',
    facet: 2
  },
  {
    id: '458f3957-2359-4077-ade1-34525d633063',
    text: 'Jag älskar stora fester',
    keyed: 'plus',
    domain: 'E',
    facet: 2
  },
  {
    id: '58d571e5-d725-4cf8-a438-32c16ee28eb6',
    text: 'Jag tycker att konst är viktigt',
    keyed: 'plus',
    domain: 'O',
    facet: 2
  },
  {
    id: '0cf79e27-e702-45c2-9471-04ac96b58e0e',
    text: 'Jag använder andra själviskt för att nå mina mål',
    keyed: 'minus',
    domain: 'A',
    facet: 2
  },
  {
    id: 'cda1ca17-b599-4561-a6cd-ff9d36062d27',
    text: 'Jag tycker om att städa upp',
    keyed: 'plus',
    domain: 'C',
    facet: 2
  },
  {
    id: '5e8550d7-b8ef-4905-950a-f81d735d39e2',
    text: 'Jag känner mig ofta nere',
    keyed: 'plus',
    domain: 'N',
    facet: 3
  },
  {
    id: '8af754f2-68e9-48f3-8c5d-2e6633d4472c',
    text: 'Jag tar kommandot',
    keyed: 'plus',
    domain: 'E',
    facet: 3
  },
  {
    id: '0727def6-3d18-4221-bf38-86b58f9f3eed',
    text: 'Jag upplever mina känslor intensivt',
    keyed: 'plus',
    domain: 'O',
    facet: 3
  },
  {
    id: 'ccf3a5c8-fb50-4bd4-8e7a-22af3d657279',
    text: 'Jag älskar att hjälpa andra',
    keyed: 'plus',
    domain: 'A',
    facet: 3
  },
  {
    id: '73d84e5d-cbf5-47f0-b8cb-4d2159a52e32',
    text: 'Jag håller mina löften',
    keyed: 'plus',
    domain: 'C',
    facet: 3
  },
  {
    id: 'b2d9ef74-73f5-4ea8-b00c-7aaca15937df',
    text: 'Jag tycker det är svårt att ta kontakt med andra',
    keyed: 'plus',
    domain: 'N',
    facet: 4
  },
  {
    id: '48a761ef-438e-409b-ae59-ea2ce8f84414',
    text: 'Jag är alltid upptagen',
    keyed: 'plus',
    domain: 'E',
    facet: 4
  },
  {
    id: 'cae55842-8957-4e3b-83b3-ceff98fb9dcf',
    text: 'Jag föredrar variation framför rutin',
    keyed: 'plus',
    domain: 'O',
    facet: 4
  },
  {
    id: 'e2028ad3-b128-4f76-be57-398bfe2aff22',
    text: 'Jag gillar när en diskussion blir riktigt intensiv',
    keyed: 'minus',
    domain: 'A',
    facet: 4
  },
  {
    id: 'b7fc949b-02b6-4cb9-a3e2-dbb3d824b55f',
    text: 'Jag arbetar hårt',
    keyed: 'plus',
    domain: 'C',
    facet: 4
  },
  {
    id: '481efd08-c810-43b1-a952-f8ac9052f96b',
    text: 'Jag gör (eller konsumerar) för mycket av saker jag inte borde',
    keyed: 'plus',
    domain: 'N',
    facet: 5
  },
  {
    id: '987efee2-899f-4a65-b9b5-1589ef0460d7',
    text: 'Jag älskar spänning',
    keyed: 'plus',
    domain: 'E',
    facet: 5
  },
  {
    id: 'e1e804c7-4a1d-498f-8610-f95147af9d1d',
    text: 'Jag älskar att läsa utmanande skrifter',
    keyed: 'plus',
    domain: 'O',
    facet: 5
  },
  {
    id: '71029381-3908-4c68-91e1-e41fb45542a2',
    text: 'Jag tror att jag är bättre än andra',
    keyed: 'minus',
    domain: 'A',
    facet: 5
  },
  {
    id: 'f6076eea-56ae-4b46-97f1-5f94a7676c96',
    text: 'Jag är alltid förberedd',
    keyed: 'plus',
    domain: 'C',
    facet: 5
  },
  {
    id: '2f519935-92e8-48ad-9746-4a0f8b38466a',
    text: 'Jag blir lätt panikslagen',
    keyed: 'plus',
    domain: 'N',
    facet: 6
  },
  {
    id: '899c3f66-51d0-46ea-963a-6fc36d3b3cb9',
    text: 'Jag sprider glädje',
    keyed: 'plus',
    domain: 'E',
    facet: 6
  },
  {
    id: '79186f48-e7fa-4df4-b74b-b0627ee244e1',
    text: 'Jag brukar rösta på partier som bryr sig om människor',
    keyed: 'plus',
    domain: 'O',
    facet: 6
  },
  {
    id: 'fd50e1ca-d9e0-4037-a7a1-a191d4db2d96',
    text: 'Jag sympatiserar med de hemlösa',
    keyed: 'plus',
    domain: 'A',
    facet: 6
  },
  {
    id: 'bd9eec0a-b68b-472c-8803-7db29c308cdb',
    text: 'Jag åtar mig saker utan att tänka efter',
    keyed: 'minus',
    domain: 'C',
    facet: 6
  },
  {
    id: '7f92ab2c-265c-4b84-8c74-09f9bb9d41a7',
    text: 'Jag väntar mig att saker slutar illa',
    keyed: 'plus',
    domain: 'N',
    facet: 1
  },
  {
    id: 'af55f014-788c-4b6e-92c4-b2b59dc8a28d',
    text: 'Jag trivs när det finns människor omkring mig',
    keyed: 'plus',
    domain: 'E',
    facet: 1
  },
  {
    id: '08ff6dca-02a5-4aeb-aaa4-2ecf2526f143',
    text: 'Jag gillar att fantisera vilt',
    keyed: 'plus',
    domain: 'O',
    facet: 1
  },
  {
    id: '6f66cdc0-9044-457b-b40d-501ecae15ee7',
    text: 'Jag tror att de flesta har goda avsikter',
    keyed: 'plus',
    domain: 'A',
    facet: 1
  },
  {
    id: 'f110fc66-2e9e-413c-920b-19f05e63d7ac',
    text: 'Jag är mycket bra på det jag gör',
    keyed: 'plus',
    domain: 'C',
    facet: 1
  },
  {
    id: '7dab2a37-8635-4fc7-86b7-0abf13c183c9',
    text: 'Jag blir lätt irriterad',
    keyed: 'plus',
    domain: 'N',
    facet: 2
  },
  {
    id: '28ab59a0-e7cd-4fce-94e3-bba2ecc023b6',
    text: 'Jag pratar med många olika på fester',
    keyed: 'plus',
    domain: 'E',
    facet: 2
  },
  {
    id: 'b5919f2f-cded-4745-a9ce-c02703cee807',
    text: 'Jag ser skönhet i saker de flesta inte lägger märke till',
    keyed: 'plus',
    domain: 'O',
    facet: 2
  },
  {
    id: '5a5fa975-d024-4ac8-8845-2823f957c21b',
    text: 'Jag är oärlig för att ta mig framåt och uppåt',
    keyed: 'minus',
    domain: 'A',
    facet: 2
  },
  {
    id: 'adf33f9f-45bd-43e3-af25-4c491176d97f',
    text: 'Jag glömmer ofta att lägga tillbaka saker på sin rätta plats',
    keyed: 'minus',
    domain: 'C',
    facet: 2
  },
  {
    id: 'f0a14e16-d726-47e9-a2c1-647fd3d7d52e',
    text: 'Jag tycker illa om mig själv',
    keyed: 'plus',
    domain: 'N',
    facet: 3
  },
  {
    id: '0b38e3d3-c15c-454c-b034-f4eb7ae1580a',
    text: 'Jag försöker att leda andra',
    keyed: 'plus',
    domain: 'E',
    facet: 3
  },
  {
    id: '5631b856-ff34-4f76-a0cd-edc7104c3bfa',
    text: 'Jag känner andra människors känslor',
    keyed: 'plus',
    domain: 'O',
    facet: 3
  },
  {
    id: 'ada867af-4db1-4e3d-a604-2b695c1806e5',
    text: 'Jag bryr mig om andra',
    keyed: 'plus',
    domain: 'A',
    facet: 3
  },
  {
    id: 'c55e3958-00c4-4fc3-9118-47d8f31bfde1',
    text: 'Jag talar sanning',
    keyed: 'plus',
    domain: 'C',
    facet: 3
  },
  {
    id: 'acd8fadc-5399-4a67-b5ff-9d1ada049c01',
    text: 'Jag är rädd för att dra uppmärksamhet mot mig',
    keyed: 'plus',
    domain: 'N',
    facet: 4
  },
  {
    id: 'd07b6c67-0d02-4948-a997-bb84ac234cd8',
    text: 'Jag har alltid något på gång',
    keyed: 'plus',
    domain: 'E',
    facet: 4
  },
  {
    id: '33b81fd0-7e32-4cd8-a13a-d5f5f754f998',
    text: 'Jag föredrar att hålla mig till saker jag känner till',
    keyed: 'minus',
    domain: 'O',
    facet: 4
  },
  {
    id: 'd9a9a180-29c9-4ec5-8621-2256d411def7',
    text: 'Jag gapar/skriker på andra',
    keyed: 'minus',
    domain: 'A',
    facet: 4
  },
  {
    id: 'f12c3d9d-1d12-4aa6-ad2e-009cd0651cbb',
    text: 'Jag gör mer än vad som förväntas av mig',
    keyed: 'plus',
    domain: 'C',
    facet: 4
  },
  {
    id: '9891b7ba-a494-4307-aafe-301d8db506c6',
    text: 'Jag ger sällan oaktat utlopp för mina begär',
    keyed: 'minus',
    domain: 'N',
    facet: 5
  },
  {
    id: 'f1675af6-88bf-4376-a946-0281e762b39c',
    text: 'Jag söker äventyr',
    keyed: 'plus',
    domain: 'E',
    facet: 5
  },
  {
    id: '95a3f20c-f933-4d19-a2c1-a7dbdf63c562',
    text: 'Jag undviker filosofiska diskussioner',
    keyed: 'minus',
    domain: 'O',
    facet: 5
  },
  {
    id: '7df44711-4cd4-4b05-8830-73fcc3ebdab5',
    text: 'Jag har höga tankar om mig själv',
    keyed: 'minus',
    domain: 'A',
    facet: 5
  },
  {
    id: '9d3cb5c7-955c-43a4-b6c7-b07ed01dcbd9',
    text: 'Jag genomför mina planer',
    keyed: 'plus',
    domain: 'C',
    facet: 5
  },
  {
    id: '13c58810-3864-42ba-aa87-d4166f858756',
    text: 'Jag blir överväldigad av större händelser',
    keyed: 'plus',
    domain: 'N',
    facet: 6
  },
  {
    id: '961376e0-16a1-4c14-b059-789e63d11b63',
    text: 'Jag har roligt ofta',
    keyed: 'plus',
    domain: 'E',
    facet: 6
  },
  {
    id: 'f08e1b27-3673-4898-9cae-896482d0d9f9',
    text: 'Jag tror inte att saker eller handlingar enbart är rätt eller fel',
    keyed: 'plus',
    domain: 'O',
    facet: 6
  },
  {
    id: 'c2038c12-7a37-47a8-9983-831bd6692aab',
    text: 'Jag känner sympati med de som har det sämre än jag',
    keyed: 'plus',
    domain: 'A',
    facet: 6
  },
  {
    id: '956f3e17-ff17-4af5-a52f-9222b8968106',
    text: 'Jag tar förhastade beslut',
    keyed: 'minus',
    domain: 'C',
    facet: 6
  },
  {
    id: '4d81238b-5407-47d4-88e5-dc0e38aa14f5',
    text: 'Jag är rädd för mycket',
    keyed: 'plus',
    domain: 'N',
    facet: 1
  },
  {
    id: '9f9166f0-fa94-4c14-a91d-3eecd8395794',
    text: 'Jag undviker kontakter med andra',
    keyed: 'minus',
    domain: 'E',
    facet: 1
  },
  {
    id: '23a1034f-fab7-4887-a66e-5ef4eaafb25e',
    text: 'Jag älskar att dagdrömma',
    keyed: 'plus',
    domain: 'O',
    facet: 1
  },
  {
    id: 'c63e6121-c3ed-40cc-abc2-c1e6ea1e0858',
    text: 'Jag litar på vad folk säger',
    keyed: 'plus',
    domain: 'A',
    facet: 1
  },
  {
    id: '02ee1930-36a7-4caa-b10c-c93efb682a44',
    text: 'Jag hanterar uppgifter utan besvär',
    keyed: 'plus',
    domain: 'C',
    facet: 1
  },
  {
    id: 'da8e6ed1-2296-4c58-8fdb-66f2f591989b',
    text: 'Jag tappar humöret',
    keyed: 'plus',
    domain: 'N',
    facet: 2
  },
  {
    id: '03c10b30-b88f-4c63-8acc-71251ca24615',
    text: 'Jag föredrar att vara ensam',
    keyed: 'minus',
    domain: 'E',
    facet: 2
  },
  {
    id: '751a04bc-5adf-485a-8ea4-4308406ae85b',
    text: 'Jag gillar inte poesi',
    keyed: 'minus',
    domain: 'O',
    facet: 2
  },
  {
    id: '982e83c2-d34e-48da-9c71-78494ab05c85',
    text: 'Jag utnyttjar andra',
    keyed: 'minus',
    domain: 'A',
    facet: 2
  },
  {
    id: 'f4891687-0ff0-47af-a4f6-d1202c8f6676',
    text: 'Jag lämnar mitt rum i en enda röra',
    keyed: 'minus',
    domain: 'C',
    facet: 2
  },
  {
    id: '743d8973-1de1-4485-91b4-8a5cf63e7d44',
    text: 'Jag är ofta deppig',
    keyed: 'plus',
    domain: 'N',
    facet: 3
  },
  {
    id: '2452f034-8273-4f71-9122-a40f5ead31ba',
    text: 'Jag tar kontroll över situationen',
    keyed: 'plus',
    domain: 'E',
    facet: 3
  },
  {
    id: '2a300001-6e05-4c79-b8b5-2ccae4c3d463',
    text: 'Jag lägger sällan märke till mina emotionella reaktioner',
    keyed: 'minus',
    domain: 'O',
    facet: 3
  },
  {
    id: 'cd54bd76-ca9c-4030-b325-bb8d896bcb3f',
    text: 'Jag är likgiltig inför andras känslor',
    keyed: 'minus',
    domain: 'A',
    facet: 3
  },
  {
    id: '4e6e3a34-176f-4e6e-8730-1341611f972b',
    text: 'Jag bryter regler',
    keyed: 'minus',
    domain: 'C',
    facet: 3
  },
  {
    id: '20062533-a33d-4c1e-9cd9-bff868015b3f',
    text: 'Jag känner mig bara tillfreds bland vänner',
    keyed: 'plus',
    domain: 'N',
    facet: 4
  },
  {
    id: 'b2a077d5-1fe0-4b06-ab63-35455e001e54',
    text: 'Jag gör massor på min fritid',
    keyed: 'plus',
    domain: 'E',
    facet: 4
  },
  {
    id: '0d2e65ab-95d9-482f-beb4-3239a3a4944a',
    text: 'Jag tycker illa om förändringar',
    keyed: 'minus',
    domain: 'O',
    facet: 4
  },
  {
    id: '0de0f900-cede-4538-9c00-5da4f830b028',
    text: 'Jag förolämpar folk',
    keyed: 'minus',
    domain: 'A',
    facet: 4
  },
  {
    id: 'a9c97d6b-6721-4150-8d84-64ef3082f164',
    text: 'Jag arbetar bara tillräckligt för att klara mig',
    keyed: 'minus',
    domain: 'C',
    facet: 4
  },
  {
    id: '9f2e7f90-0ca5-4ed0-9fe5-e060238a9b5e',
    text: 'Jag står emot frestelser utan problem',
    keyed: 'minus',
    domain: 'N',
    facet: 5
  },
  {
    id: '7dd6cf2d-5c14-48c2-8ae5-633a7a596c71',
    text: 'Jag tycker om att vara obetänksam',
    keyed: 'plus',
    domain: 'E',
    facet: 5
  },
  {
    id: 'fecc35f7-681e-4889-a404-4a973a3dfef0',
    text: 'Jag har svårt att förstå abstrakta idéer',
    keyed: 'minus',
    domain: 'O',
    facet: 5
  },
  {
    id: '1d686958-6fe7-432f-85e6-186b99e4e232',
    text: 'Jag har en positiv uppfattning om mig själv',
    keyed: 'minus',
    domain: 'A',
    facet: 5
  },
  {
    id: 'c7db0ed8-df7d-49bf-942f-59e46ef743c4',
    text: 'Jag slösar bort min tid',
    keyed: 'minus',
    domain: 'C',
    facet: 5
  },
  {
    id: 'b7e0e393-9b21-4e0d-adf3-8f28fb5b9d87',
    text: 'Jag tycker att jag har svårt att handskas med saker',
    keyed: 'plus',
    domain: 'N',
    facet: 6
  },
  {
    id: '79d956e8-1118-402a-a0e2-9380af18243e',
    text: 'Jag älskar livet',
    keyed: 'plus',
    domain: 'E',
    facet: 6
  },
  {
    id: '96ba77b2-1a44-4dfd-95f9-ae4d1f714460',
    text: 'Jag brukar rösta på de konservativa partierna',
    keyed: 'minus',
    domain: 'O',
    facet: 6
  },
  {
    id: '77f54ab4-0fba-4efb-8700-066c7490eb87',
    text: 'Jag är inte intresserad av andra människors problem',
    keyed: 'minus',
    domain: 'A',
    facet: 6
  },
  {
    id: 'a354cf7c-8d11-46ac-acc5-da90d2048637',
    text: 'Jag kastar mig över saker',
    keyed: 'minus',
    domain: 'C',
    facet: 6
  },
  {
    id: '43b03992-3f32-4ed1-a6f8-5d6d3e7ed246',
    text: 'Jag blir lätt stressad',
    keyed: 'plus',
    domain: 'N',
    facet: 1
  },
  {
    id: '41702602-08e4-4e2b-9a19-291d9efc581a',
    text: 'Jag håller andra på avstånd',
    keyed: 'minus',
    domain: 'E',
    facet: 1
  },
  {
    id: '935a7413-abac-4f54-9169-d1fbd39da752',
    text: 'Jag tycker om att försvinna i tankar',
    keyed: 'plus',
    domain: 'O',
    facet: 1
  },
  {
    id: '432dbde8-8756-4ff0-80d5-f47018235139',
    text: 'Jag misstror människor',
    keyed: 'minus',
    domain: 'A',
    facet: 1
  },
  {
    id: '5727c93f-317b-4af1-a686-77fc9fbc5033',
    text: 'Jag vet hur man får saker gjorda',
    keyed: 'plus',
    domain: 'C',
    facet: 1
  },
  {
    id: 'd32bd062-4eb2-401b-99b2-e7afea39ca9b',
    text: 'Jag är svår att göra arg',
    keyed: 'minus',
    domain: 'N',
    facet: 2
  },
  {
    id: '9a47184f-6046-4e68-a61b-3d9b357b86ea',
    text: 'Jag undviker folksamlingar',
    keyed: 'minus',
    domain: 'E',
    facet: 2
  },
  {
    id: '87c5b27e-59a8-4c48-8ba8-f5413d735693',
    text: 'Jag gillar inte att gå på konstmuseum',
    keyed: 'minus',
    domain: 'O',
    facet: 2
  },
  {
    id: '11b20adb-abed-4363-894c-3dd823ae0540',
    text: 'Jag lägger hinder i vägen för andras planer',
    keyed: 'minus',
    domain: 'A',
    facet: 2
  },
  {
    id: '50418d86-712c-45d9-adc4-ea0231c93cf5',
    text: 'Jag lämnar mina saker liggande överallt',
    keyed: 'minus',
    domain: 'C',
    facet: 2
  },
  {
    id: 'f40e421f-6c24-4be2-bd9f-28d33358d8c6',
    text: 'Jag känner mig bekväm i mig själv',
    keyed: 'minus',
    domain: 'N',
    facet: 3
  },
  {
    id: '8791f37b-686f-47c3-9db7-74c009951321',
    text: 'Jag väntar på att andra ska visa vägen',
    keyed: 'minus',
    domain: 'E',
    facet: 3
  },
  {
    id: '4fd25155-9cc2-4cd6-8852-3e0ca2d5e95d',
    text: 'Jag förstår inte människor som blir känslosamma',
    keyed: 'minus',
    domain: 'O',
    facet: 3
  },
  {
    id: 'b68af20d-24f9-4c27-85cc-fe0858994888',
    text: 'Jag tar mig inte tid för andra',
    keyed: 'minus',
    domain: 'A',
    facet: 3
  },
  {
    id: '54423933-0ebb-44a7-bdd9-2a9b100c70f2',
    text: 'Jag bryter mina löften',
    keyed: 'minus',
    domain: 'C',
    facet: 3
  },
  {
    id: '7317848c-3e1b-422f-bb16-02efc504f677',
    text: 'Jag blir inte störd av besvärliga sociala situationer',
    keyed: 'minus',
    domain: 'N',
    facet: 4
  },
  {
    id: '7d93e1ca-46e8-4a30-9623-42a80c9b420c',
    text: 'Jag tycker om att ta det lugnt',
    keyed: 'minus',
    domain: 'E',
    facet: 4
  },
  {
    id: 'a7f43928-8982-4ed5-8656-7a80346fe979',
    text: 'Jag håller fast vid konventionella tillvägagångssätt',
    keyed: 'minus',
    domain: 'O',
    facet: 4
  },
  {
    id: '17910a55-a64a-4ed0-8b46-293e2fa2fe03',
    text: 'Jag tar revansch på andra',
    keyed: 'minus',
    domain: 'A',
    facet: 4
  },
  {
    id: '3890bb43-2695-4b8d-b289-ee10d11cc884',
    text: 'Jag lägger lite tid och energi på mitt arbete',
    keyed: 'minus',
    domain: 'C',
    facet: 4
  },
  {
    id: '49a85680-53aa-4208-86b5-dccc7a6f8e37',
    text: 'Jag kan hålla mina begär i styr',
    keyed: 'minus',
    domain: 'N',
    facet: 5
  },
  {
    id: '10f90fa9-649c-4631-ac4c-3dd3f751597d',
    text: 'Jag agerar vilt och galet',
    keyed: 'plus',
    domain: 'E',
    facet: 5
  },
  {
    id: 'b86de003-c3c4-4cc8-9385-5ac8a0142c34',
    text: 'Jag är inte intresserad av teoretiska diskussioner',
    keyed: 'minus',
    domain: 'O',
    facet: 5
  },
  {
    id: '80c1d149-7050-481a-9953-aefb441642e7',
    text: 'Jag skryter om mina bra egenskaper',
    keyed: 'minus',
    domain: 'A',
    facet: 5
  },
  {
    id: '51403620-968c-42fa-a772-65ba5ad8396f',
    text: 'Jag har svårt att sätta igång med saker',
    keyed: 'minus',
    domain: 'C',
    facet: 5
  },
  {
    id: '88a3c2fe-3aa4-4f46-9322-da656332268a',
    text: 'Jag håller mig lugn även när mycket står på spel',
    keyed: 'minus',
    domain: 'N',
    facet: 6
  },
  {
    id: 'e7b31bdc-5f6b-40ec-ba91-f5919b0f170e',
    text: 'Jag ser livet från den ljusa sidan',
    keyed: 'plus',
    domain: 'E',
    facet: 6
  },
  {
    id: '580b08d1-3c94-46e9-9d07-d6d80c698127',
    text: 'Jag tycker att straffen för brottslighet ska vara hårda',
    keyed: 'minus',
    domain: 'O',
    facet: 6
  },
  {
    id: '48bee420-60c0-45cd-be43-3893dbc1969a',
    text: 'Jag försöker att inte tänka på de behövande',
    keyed: 'minus',
    domain: 'A',
    facet: 6
  },
  {
    id: 'ea3327ea-3529-4be4-8e2d-2174731ae4d7',
    text: 'Jag agerar utan att tänka',
    keyed: 'minus',
    domain: 'C',
    facet: 6
  }
]

export const choices_sv = {
  plus: [
    {
      text: 'Stämmer absolut inte',
      score: 1,
      color: 1
    },
    {
      text: 'Stämmer ganska dåligt',
      score: 2,
      color: 2
    },
    {
      text: 'Stämmer varken bra eller dåligt',
      score: 3,
      color: 3
    },
    {
      text: 'Stämmer ganska bra',
      score: 4,
      color: 4
    },
    {
      text: 'Stämmer absolut',
      score: 5,
      color: 5
    }
  ],
  minus: [
    {
      text: 'Stämmer absolut inte',
      score: 5,
      color: 1
    },
    {
      text: 'Stämmer ganska dåligt',
      score: 4,
      color: 2
    },
    {
      text: 'Stämmer varken bra eller dåligt',
      score: 3,
      color: 3
    },
    {
      text: 'Stämmer ganska bra',
      score: 2,
      color: 4
    },
    {
      text: 'Stämmer absolut',
      score: 1,
      color: 5
    }
  ]
}

type Score = 'low' | 'neutral' | 'high';

export interface Result {
  score: Score;
  text: string;
}

export interface Facet {
  facet: number;
  title: string;
  text: string;
}

export interface TemplateDomain {
  domain: string;
  title: string;
  shortDescription: string;
  description: string;
  results: Result[];
  facets: Facet[];
}

export const agreeableness_en: TemplateDomain = {
  domain: 'A',
  title: 'Agreeableness',
  shortDescription: 'Agreeableness reflects individual differences in concern with cooperation and social harmony. Agreeable individuals value getting along with others.',
  description: `They are therefore considerate, friendly,
generous, helpful, and willing to compromise their interests with
others'. Agreeable people also have an optimistic view of human
nature. They believe people are basically honest, decent, and
trustworthy. <br /><br />
Disagreeable individuals place self-interest above getting along with
others.  They are generally unconcerned with others' well-being, and
therefore are unlikely to extend themselves for other people.
Sometimes their skepticism about others' motives causes them to be
suspicious, unfriendly, and uncooperative.
<br /><br />
Agreeableness is obviously advantageous for attaining and maintaining
popularity. Agreeable people are better liked than disagreeable
people. On the other hand, agreeableness is not useful in situations
that require tough or absolute objective decisions. Disagreeable
people can make excellent scientists, critics, or soldiers.`,
  results: [
    {
      score: 'low', // do not translate this line
      text: `Your score on Agreeableness is low, indicating less concern
with others' needs than with your own. People see you as tough,
critical, and uncompromising.`
    },
    {
      score: 'neutral', // do not translate this line
      text: `Your level of Agreeableness is average, indicating some concern
with others' Needs, but, generally, unwillingness to sacrifice
yourself for others.`
    },
    {
      score: 'high', // do not translate this line
      text: `Your high level of Agreeableness indicates a strong interest in
others' needs and well-being. You are pleasant, sympathetic, and
cooperative.`
    }
  ],
  facets: [
    {
      facet: 1,
      title: 'Trust',
      text: `A person with high trust assumes that most people
are fair, honest, and have good intentions. Persons low in trust
see others as selfish, devious, and potentially dangerous.`
    },
    {
      facet: 2,
      title: 'Morality',
      text: `High scorers on this scale see no need for
pretense or manipulation when dealing with others and are therefore
candid, frank, and sincere. Low scorers believe that a certain
amount of deception in social relationships is necessary. People
find it relatively easy to relate to the straightforward
high-scorers on this scale. They generally find it more difficult
to relate to the unstraightforward low-scorers on this scale. It
should be made clear that low scorers are not unprincipled
or immoral; they are simply more guarded and less willing to openly
reveal the whole truth.`
    },
    {
      facet: 3,
      title: 'Altruism',
      text: `Altruistic people find helping other people
genuinely rewarding. Consequently, they are generally willing to
assist those who are in need. Altruistic people find that doing
things for others is a form of self-fulfillment rather than
self-sacrifice. Low scorers on this scale do not particularly like
helping those in need. Requests for help feel like an imposition
rather than an opportunity for self-fulfillment.`
    },
    {
      facet: 4,
      title: 'Cooperation',
      text: `Individuals who score high on this scale
dislike confrontations. They are perfectly willing to compromise or
to deny their own needs in order to get along with others. Those
who score low on this scale are more likely to intimidate others to
get their way.`
    },
    {
      facet: 5,
      title: 'Modesty',
      text: `High scorers on this scale do not like to claim
that they are better than other people. In some cases this attitude
may derive from low self-confidence or self-esteem. Nonetheless,
some people with high self-esteem find immodesty unseemly. Those
who are willing to describe themselves as superior tend to
be seen as disagreeably arrogant by other people.`
    },
    {
      facet: 6,
      title: 'Sympathy',
      text: `People who score high on this scale are
tenderhearted and compassionate. They feel the pain of others
vicariously and are easily moved to pity. Low scorers are not
affected strongly by human suffering. They pride themselves on
making objective judgments based on reason. They are more concerned
with truth and impartial justice than with mercy.`
    }
  ]
}

export const conscientiousness_en: TemplateDomain = {
  domain: 'C',
  title: 'Conscientiousness',
  shortDescription: 'Conscientiousness concerns the way in which we control, regulate, and direct our impulses.',
  description: `Impulses are not inherently bad;
occasionally time constraints require a snap decision, and acting on
our first impulse can be an effective response. Also, in times of
play rather than work, acting spontaneously and impulsively can be
fun. Impulsive individuals can be seen by others as colorful,
fun-to-be-with, and zany.
<br /><br />
Nonetheless, acting on impulse can lead to trouble in a number of
ways. Some impulses are antisocial. Uncontrolled antisocial acts
not only harm other members of society, but also can result in
retribution toward the perpetrator of such impulsive acts. Another
problem with impulsive acts is that they often produce immediate
rewards but undesirable, long-term consequences. Examples include
excessive socializing that leads to being fired from one's job,
hurling an insult that causes the breakup of an important
relationship, or using pleasure-inducing drugs that eventually
destroy one's health.
<br /><br />
Impulsive behavior, even when not seriously destructive, diminishes
a person's effectiveness in significant ways. Acting impulsively
disallows contemplating alternative courses of action, some of which
would have been wiser than the impulsive choice. Impulsivity also
sidetracks people during projects that require organized sequences
of steps or stages. Accomplishments of an impulsive person are
therefore small, scattered, and inconsistent.
<br /><br />
A hallmark of intelligence, what potentially separates human beings
from earlier life forms, is the ability to think about future
consequences before acting on an impulse. Intelligent activity
involves contemplation of long-range goals, organizing and planning
routes to these goals, and persisting toward one's goals in the face
of short-lived impulses to the contrary. The idea that intelligence
involves impulse control is nicely captured by the term prudence, an
alternative label for the Conscientiousness domain. Prudent means
both wise and cautious.
<br /><br/>
Persons who score high on the
Conscientiousness scale are, in fact, perceived by others as intelligent.
The benefits of high conscientiousness are obvious. Conscientious
individuals avoid trouble and achieve high levels of success through
purposeful planning and persistence. They are also positively
regarded by others as intelligent and reliable. On the negative
side, they can be compulsive perfectionists and workaholics.
Furthermore, extremely conscientious individuals might be regarded
as stuffy and boring.
<br /><br />
Unconscientious people may be criticized for
their unreliability, lack of ambition, and failure to stay within
the lines, but they will experience many short-lived pleasures and
they will never be called stuffy.`,
  results: [
    {
      score: 'low', // do not translate this line
      text: `Your score on Conscientiousness is low, indicating you like to live
for the moment and do what feels good now. Your work tends to be
careless and disorganized.`
    },
    {
      score: 'neutral', // do not translate this line
      text: `Your score on Conscientiousness is average. This means you are
reasonably reliable, organized, and self-controlled.`
    },
    {
      score: 'high', // do not translate this line
      text: `Your score on Conscientiousness is high. This means you set clear
goals and pursue them with determination. People regard you as
reliable and hard-working.`
    }
  ],
  facets: [
    {
      facet: 1,
      title: 'Self-Efficacy',
      text: `Self-Efficacy describes confidence in one's ability
to accomplish things. High scorers believe they have the intelligence
(common sense), drive, and self-control necessary for achieving success.
Low scorers do not feel effective, and may have a sense that they are not
in control of their lives.`
    },
    {
      facet: 2,
      title: 'Orderliness',
      text: `Persons with high scores on orderliness are
well-organized. They like to live according to routines and schedules. They
keep lists and make plans. Low scorers tend to be disorganized and
scattered.`
    },
    {
      facet: 3,
      title: 'Dutifulness',
      text: `This scale reflects the strength of a person's sense
 of duty and obligation. Those who score high on this scale have a strong
 sense of moral obligation. Low scorers find contracts, rules, and
 regulations overly confining. They are likely to be seen as unreliable or
 even irresponsible.`
    },
    {
      facet: 4,
      title: 'Achievement-Striving',
      text: `Individuals who score high on this
scale strive hard to achieve excellence. Their drive to be recognized as
successful keeps them on track toward their lofty goals. They often have
a strong sense of direction in life, but extremely high scores may
be too single-minded and obsessed with their work. Low scorers are content
to get by with a minimal amount of work, and might be seen by others
as lazy.`
    },
    {
      facet: 5,
      title: 'Self-Discipline',
      text: `Self-discipline-what many people call
will-power-refers to the ability to persist at difficult or unpleasant
tasks until they are completed. People who possess high self-discipline
are able to overcome reluctance to begin tasks and stay on track despite
distractions. Those with low self-discipline procrastinate and show poor
follow-through, often failing to complete tasks-even tasks they want very
much to complete.`
    },
    {
      facet: 6,
      title: 'Cautiousness',
      text: `Cautiousness describes the disposition to
think through possibilities before acting. High scorers on the Cautiousness
scale take their time when making decisions. Low scorers often say or do
first thing that comes to mind without deliberating alternatives and the
probable consequences of those alternatives.`
    }
  ]
}

export const extraversion_en: TemplateDomain = {
  domain: 'E',
  title: 'Extraversion',
  shortDescription: 'Extraversion is marked by pronounced engagement with the external world.',
  description: `Extraverts enjoy being with people, are full of energy, and
often experience positive emotions. They tend to be enthusiastic,
action-oriented, individuals who are likely to say "Yes!" or "Let's
go!" to opportunities for excitement. In groups they like to talk,
assert themselves, and draw attention to themselves.
<br /><br />
Introverts lack the exuberance, energy, and activity levels of
extraverts. They tend to be quiet, low-key, deliberate, and
disengaged from the social world. Their lack of social involvement
should not be interpreted as shyness or depression; the
introvert simply needs less stimulation than an extravert and prefers
to be alone. <br /><br />The independence and reserve of the introvert is
sometimes mistaken as unfriendliness or arrogance. In reality, an
introvert who scores high on the agreeableness dimension will not
seek others out but will be quite pleasant when approached.`,
  results: [
    {
      score: 'low', // do not translate this line
      text: `Your score on Extraversion is low, indicating you are
introverted, reserved, and quiet. You enjoy solitude and solitary
activities. Your socialization tends to be restricted to a few close friends.`
    },
    {
      score: 'neutral', // do not translate this line
      text: `Your score on Extraversion is average, indicating you are
neither a subdued loner nor a jovial chatterbox. You enjoy time with
others but also time alone.`
    },
    {
      score: 'high', // do not translate this line
      text: `Your score on Extraversion is high, indicating you are
sociable, outgoing, energetic, and lively. You prefer to be around
people much of the time.`
    }
  ],
  facets: [
    {
      facet: 1,
      title: 'Friendliness',
      text: `Friendly people genuinely like other people
and openly demonstrate positive feelings toward others. They make
friends quickly and it is easy for them to form close, intimate
relationships. Low scorers on Friendliness are not necessarily cold
and hostile, but they do not reach out to others and are perceived
as distant and reserved.`
    },
    {
      facet: 2,
      title: 'Gregariousness',
      text: `Gregarious people find the company of
others pleasantly stimulating and rewarding. They enjoy the
excitement of crowds. Low scorers tend to feel overwhelmed by, and
therefore actively avoid, large crowds. They do not necessarily
dislike being with people sometimes, but their need for privacy and
time to themselves is much greater than for individuals who score
high on this scale.`
    },
    {
      facet: 3,
      title: 'Assertiveness',
      text: `High scorers Assertiveness like to speak
 out, take charge, and direct the activities of others. They tend to
 be leaders in groups. Low scorers tend not to talk much and let
 others control the activities of groups.`
    },
    {
      facet: 4,
      title: 'Activity Level',
      text: `Active individuals lead fast-paced, busy
 lives. They move about quickly, energetically, and vigorously, and
 they are involved in many activities. People who score low on this
 scale follow a slower and more leisurely, relaxed pace.`
    },
    {
      facet: 5,
      title: 'Excitement-Seeking',
      text: `High scorers on this scale are easily
bored without high levels of stimulation. They love bright lights
and hustle and bustle. They are likely to take risks and seek
thrills. Low scorers are overwhelmed by noise and commotion and are
adverse to thrill-seeking.`
    },
    {
      facet: 6,
      title: 'Cheerfulness',
      text: `This scale measures positive mood and
feelings, not negative emotions (which are a part of the
Neuroticism domain). Persons who score high on this scale typically
experience a range of positive feelings, including happiness,
enthusiasm, optimism, and joy. Low scorers are not as prone to such
energetic, high spirits.`
    }
  ]
}

export const neuroticism_en: TemplateDomain = {
  domain: 'N',
  title: 'Neuroticism',
  shortDescription: 'Neuroticism refers to the tendency to experience negative feelings.',
  description: `Freud originally used the term neurosis to describe a
condition marked by mental distress, emotional suffering, and an
inability to cope effectively with the normal demands of life. He
suggested that everyone shows some signs of neurosis, but that we
differ in our degree of suffering and our specific symptoms of
distress. Today neuroticism refers to the tendency to experience
negative feelings. <br /><br />Those who score high on Neuroticism may
experience primarily one specific negative feeling such as anxiety,
anger, or depression, but are likely to experience several of these
emotions. <br /><br />People high in neuroticism are emotionally reactive. They
respond emotionally to events that would not affect most people, and
their reactions tend to be more intense than normal. They are more
likely to interpret ordinary situations as threatening, and minor
frustrations as hopelessly difficult. <br /><br />Their negative emotional
reactions tend to persist for unusually long periods of time, which
means they are often in a bad mood. These problems in emotional
regulation can diminish a neurotic's ability to think clearly, make
decisions, and cope effectively with stress.`,
  results: [
    {
      score: 'low', // do not translate this line
      text: `Your score on Neuroticism is low, indicating that you are
exceptionally calm, composed and unflappable. You do not react with
intense emotions, even to situations that most people would describe
as stressful.`
    },
    {
      score: 'neutral', // do not translate this line
      text: `Your score on Neuroticism is average, indicating that your level of
emotional reactivity is typical of the general population.
Stressful and frustrating situations are somewhat upsetting to you,
but you are generally able to get over these feelings and cope with
these situations.`
    },
    {
      score: 'high', // do not translate this line
      text: `Your score on Neuroticism is high, indicating that you are easily
upset, even by what most people consider the normal demands of
living. People consider you to be sensitive and emotional.`
    }
  ],
  facets: [
    {
      facet: 1,
      title: 'Anxiety',
      text: `The "fight-or-flight" system of the brain of anxious
individuals is too easily and too often engaged. Therefore, people who
are high in anxiety often feel like something dangerous is about to happen.
They may be afraid of specific situations or be just generally fearful.
They feel tense, jittery, and nervous. Persons low in Anxiety are generally
calm and fearless.`
    },
    {
      facet: 2,
      title: 'Anger',
      text: `Persons who score high in Anger feel enraged when
things do not go their way. They are sensitive about being treated fairly
and feel resentful and bitter when they feel they are being cheated.
This scale measures the tendency to feel angry; whether or not the
person expresses annoyance and hostility depends on the individual's
level on Agreeableness. Low scorers do not get angry often or easily.`
    },
    {
      facet: 3,
      title: 'Depression',
      text: `This scale measures the tendency to feel sad, dejected,
and discouraged. High scorers lack energy and have difficulty initiating
activities. Low scorers tend to be free from these depressive feelings.`
    },
    {
      facet: 4,
      title: 'Self-Consciousness',
      text: `Self-conscious individuals are sensitive
about what others think of them. Their concern about rejection and
ridicule cause them to feel shy and uncomfortable around others. They
are easily embarrassed and often feel ashamed. Their fears that others
will criticize or make fun of them are exaggerated and unrealistic, but
their awkwardness and discomfort may make these fears a self-fulfilling
prophecy. Low scorers, in contrast, do not suffer from the mistaken
impression that everyone is watching and judging them. They do not feel
nervous in social situations.`
    },
    {
      facet: 5,
      title: 'Immoderation',
      text: `Immoderate individuals feel strong cravings and
urges that they have have difficulty resisting. They tend to be
oriented toward short-term pleasures and rewards rather than long-
term consequences. Low scorers do not experience strong, irresistible
cravings and consequently do not find themselves tempted to overindulge.`
    },
    {
      facet: 6,
      title: 'Vulnerability',
      text: `High scorers on Vulnerability experience
panic, confusion, and helplessness when under pressure or stress.
Low scorers feel more poised, confident, and clear-thinking when
stressed.`
    }
  ]
}

export const openness_en: TemplateDomain = {
  domain: 'O',
  title: 'Openness To Experience',
  shortDescription: 'Openness to Experience describes a dimension of cognitive style that distinguishes imaginative, creative people from down-to-earth, conventional people.',
  description: `Open people are intellectually curious,
appreciative of art, and sensitive to beauty. They tend to be,
compared to closed people, more aware of their feelings. They tend to
think and act in individualistic and nonconforming
ways. Intellectuals typically score high on Openness to Experience;
consequently, this factor has also been called Culture or
Intellect. <br /><br />Nonetheless, Intellect is probably best regarded as one aspect of openness
to experience. Scores on Openness to Experience are only modestly
related to years of education and scores on standard intelligent tests.
<br /><br />
Another characteristic of the open cognitive style is a facility for thinking
in symbols and abstractions far removed from concrete experience. Depending on
the individual's specific intellectual abilities, this symbolic cognition may
take the form of mathematical, logical, or geometric thinking, artistic and
metaphorical use of language, music composition or performance, or one of the
many visual or performing arts.
<br /><br />
People with low scores on openness to experience tend to have narrow, common
interests. They prefer the plain, straightforward, and obvious over the
complex, ambiguous, and subtle. They may regard the arts and sciences with
suspicion, regarding these endeavors as abstruse or of no practical use.
Closed people prefer familiarity over novelty; they are conservative and
resistant to change.
<br /><br />
Openness is often presented as healthier or more mature by psychologists, who
are often themselves open to experience. However, open and closed styles of
thinking are useful in different environments. The intellectual style of the
open person may serve a professor well, but research has shown that closed
thinking is related to superior job performance in police work, sales, and
a number of service occupations.`,
  results: [
    {
      score: 'low', // do not translate this line
      text: `Your score on Openness to Experience is low, indicating you like to think in
plain and simple terms. Others describe you as down-to-earth, practical,
and conservative.`
    },
    {
      score: 'neutral', // do not translate this line
      text: `Your score on Openness to Experience is average, indicating you enjoy
tradition but are willing to try new things. Your thinking is neither
simple nor complex. To others you appear to be a well-educated person
but not an intellectual.`
    },
    {
      score: 'high', // do not translate this line
      text: `Your score on Openness to Experience is high, indicating you enjoy novelty,
variety, and change. You are curious, imaginative, and creative.`
    }
  ],
  facets: [
    {
      facet: 1,
      title: 'Imagination',
      text: `To imaginative individuals, the real world is
often too plain and ordinary. High scorers on this scale use fantasy as a
way of creating a richer, more interesting world. Low scorers are on this
scale are more oriented to facts than fantasy.`
    },
    {
      facet: 2,
      title: 'Artistic Interests',
      text: `High scorers on this scale love beauty, both in
art and in nature. They become easily involved and absorbed in artistic
and natural events. They are not necessarily artistically trained nor
talented, although many will be. The defining features of this scale are
interest in, and appreciation of natural and
artificial beauty. Low scorers lack aesthetic sensitivity and interest in
the arts.`
    },
    {
      facet: 3,
      title: 'Emotionality',
      text: `Persons high on Emotionality have good access
to and awareness of their own feelings. Low scorers are less aware of
their feelings and tend not to express their emotions openly.`
    },
    {
      facet: 4,
      title: 'Adventurousness',
      text: `High scorers on adventurousness are eager to
try new activities, travel to foreign lands, and experience different
things. They find familiarity and routine boring, and will take a new
route home just because it is different. Low scorers tend to feel
uncomfortable with change and prefer familiar routines.`
    },
    {
      facet: 5,
      title: 'Intellect',
      text: `Intellect and artistic interests are the two most
important, central aspects of openness to experience. High scorers on
Intellect love to play with ideas. They are open-minded to new and unusual
ideas, and like to debate intellectual issues. They enjoy riddles, puzzles,
and brain teasers. Low scorers on Intellect prefer dealing with either
people or things rather than ideas. They regard intellectual exercises as a
waste of time. Intellect should not be equated with intelligence.
Intellect is an intellectual style, not an intellectual ability, although
high scorers on Intellect score slightly higher than low-Intellect
individuals on standardized intelligence tests.`
    },
    {
      facet: 6,
      title: 'Liberalism',
      text: `Psychological liberalism refers to a readiness to
challenge authority, convention, and traditional values. In its most
extreme form, psychological liberalism can even represent outright
hostility toward rules, sympathy for law-breakers, and love of ambiguity,
chaos, and disorder. Psychological conservatives prefer the security and
stability brought by conformity to tradition. Psychological liberalism
and conservatism are not identical to political affiliation, but certainly
incline individuals toward certain political parties.`
    }
  ]
}

export const agreeableness_sv: TemplateDomain = {
  domain: 'A',
  title: 'Medgörlighet',
  shortDescription: 'Medgörlighet beskriver individuella skillnader i omtanke, samarbetsvilja och social harmoni. Personer med hög medgörlighet värdesätter att komma överens med andra.',
  description: `Personer med hög medgörlighet är därför omtänksamma, vänliga,
generösa, hjälpsamma och villiga att kompromissa med sina egna
intressen för andras skull. De har också en optimistisk syn på
människans natur. De tror att människor i grunden är ärliga, anständiga
och pålitliga. <br /><br />
Personer med låg medgörlighet sätter sitt egenintresse före att komma
överens med andra. De bryr sig i allmänhet mindre om andras
välbefinnande och är därför mindre benägna att anstränga sig för andra.
Ibland gör deras skepsis mot andras motiv att de kan uppfattas som
misstänksamma, ovänliga och osamarbetsvilliga.
<br /><br />
Medgörlighet är tydligt gynnsamt för att nå och behålla popularitet.
Medgörliga personer är mer omtyckta än personer med låg medgörlighet.
Å andra sidan är medgörlighet inte alltid användbart i situationer som
kräver tuffa eller helt objektiva beslut. Personer med låg
medgörlighet kan vara utmärkta forskare, kritiker eller soldater.`,
  results: [
    {
      score: 'low', // do not translate this line
      text: `Ditt resultat på Medgörlighet är lågt, vilket indikerar att du bryr dig
mindre om andras behov än om dina egna. Andra kan se dig som tuff,
kritisk och kompromisslös.`
    },
    {
      score: 'neutral', // do not translate this line
      text: `Ditt resultat på Medgörlighet är genomsnittligt, vilket innebär att du
visar viss omtanke om andras behov men i allmänhet inte är villig att
offra dig själv för andra.`
    },
    {
      score: 'high', // do not translate this line
      text: `Ditt höga resultat på Medgörlighet visar på ett starkt intresse för
andras behov och välbefinnande. Du är trevlig, sympatisk och
samarbetsvillig.`
    }
  ],
  facets: [
    {
      facet: 1,
      title: 'Tillit',
      text: `En person med hög tillit antar att de flesta människor är
rättvisa, ärliga och har goda avsikter. Personer med låg tillit ser
andra som själviska, listiga och potentiellt farliga.`
    },
    {
      facet: 2,
      title: 'Moral',
      text: `Personer som får höga värden på denna skala ser inget behov av
förställning eller manipulation i mötet med andra och är därför
öppna, raka och uppriktiga. Personer med låga värden anser att en viss
mängd deception i sociala relationer är nödvändig. Andra upplever att det
är relativt lätt att relatera till personer med höga värden på denna skala.
De har i allmänhet svårare att relatera till personer med låga värden,
eftersom dessa ofta är mer återhållsamma och mindre öppna med hela
sanningen. Det bör tydliggöras att låga värden inte innebär att personen
är principlös eller omoralisk; de är helt enkelt mer försiktiga och
mindre benägna att öppet avslöja hela sanningen.`
    },
    {
      facet: 3,
      title: 'Altruism',
      text: `Altruistiska personer upplever att det är genuint
belönande att hjälpa andra. De är därför i allmänhet villiga att hjälpa
dem som behöver stöd. Altruistiska personer upplever att göra saker för
andra som en form av självförverkligande snarare än självuppoffring.
Personer som får låga värden på denna skala tycker inte särskilt mycket
om att hjälpa dem som är i behov av hjälp. Förfrågningar om hjälp känns
mer som en belastning än som en möjlighet till självförverkligande.`
    },
    {
      facet: 4,
      title: 'Samarbetsvilja',
      text: `Personer som får höga värden på denna skala
ogillar konfrontationer. De är fullt villiga att kompromissa eller
återhålla sina egna behov för att komma överens med andra. De som får
låga värden på denna skala är mer benägna att använda sig av
skrämseltaktik för att få sin vilja igenom.`
    },
    {
      facet: 5,
      title: 'Ödmjukhet',
      text: `Personer som får höga värden på denna skala tycker inte om att hävda
att de är bättre än andra människor. I vissa fall kan denna attityd
bottna i låg självkänsla. Samtidigt upplever vissa personer med hög
självkänsla att skryt är osmakligt. De som gärna beskriver sig själva
som överlägsna tenderar att uppfattas som obehagligt arroganta av andra.`
    },
    {
      facet: 6,
      title: 'Medkänsla',
      text: `Personer som får höga värden på denna skala är
mjuka och medkännande. De känner andras smärta indirekt och rörs
lätt till medlidande. Personer med låga värden påverkas inte lika starkt
av mänskligt lidande. De är stolta över att fatta objektiva bedömningar
baserade på förnuft. De är mer upptagna av sanning och opartisk rättvisa
än av barmhärtighet.`
    }
  ]
}

export const conscientiousness_sv: TemplateDomain = {
  domain: 'C',
  title: 'Samvetsgrannhet',
  shortDescription: 'Samvetsgrannhet handlar om hur vi kontrollerar, reglerar och styr våra impulser.',
  description: `Impulser är inte dåliga i sig; ibland kräver tidspress ett snabbt
beslut och att agera på sin första impuls kan vara ett effektivt svar.
Vid lek snarare än arbete kan spontant och impulsivt agerande dessutom
vara roligt. Impulsiva personer kan av andra ses som färgstarka,
roliga att vara med och lite galna.
<br /><br />
Samtidigt kan impulsivt agerande leda till problem på flera sätt. Vissa
impulser är antisociala. Okontrollerade antisociala handlingar skadar
inte bara andra människor, utan kan också leda till negativa
konsekvenser för den som agerar impulsivt. Ett annat problem med
impulsiva handlingar är att de ofta ger omedelbara belöningar men
oönskade långsiktiga konsekvenser. Exempel är alltför mycket
socialt umgänge som leder till att man blir av med jobbet, att kasta ur
sig en förolämpning som orsakar slutet på en viktig relation, eller att
använda njutningsframkallande droger som på sikt förstör hälsan.
<br /><br />
Impulsivt beteende, även när det inte är allvarligt destruktivt,
minskar en persons effektivitet på flera sätt. Att agera impulsivt
hindrar reflektion kring alternativa handlingsvägar, där vissa hade kunnat
vara klokare än det impulsiva valet. Impulsivitet gör också att personer
lätt spårar ur i projekt som kräver organiserade steg eller faser.
Resultaten för en impulsiv person blir därför små, utspridda och
inkonsekventa.
<br /><br />
Ett kännetecken för mänsklig intelligens, som skiljer människor från
tidigare livsformer, är förmågan att tänka på framtida konsekvenser
innan man agerar på en impuls. Intelligent aktivitet innebär att
reflektera över långsiktiga mål, organisera och planera vägarna dit och
att hålla fast vid målen trots kortlivade impulser i motsatt riktning.
Tanken att intelligens innefattar impulskontroll fångas väl av ordet
försiktighet, ett alternativt namn för domänen Samvetsgrannhet. Att vara
försiktig innebär både att vara klok och varsam.
<br /><br/>
Personer som får höga värden på Samvetsgrannhet uppfattas faktiskt av
andra som intelligenta. Fördelarna med hög samvetsgrannhet är tydliga.
Samvetsgranna individer undviker problem och når höga nivåer av
framgång genom målinriktad planering och uthållighet. De ses också
positivt av andra som kloka och pålitliga. På den negativa sidan kan de
bli tvångsmässiga perfektionister och arbetsnarkomaner. Mycket hög
samvetsgrannhet kan göra att man uppfattas som stel och tråkig.
<br /><br />
Personer med låg samvetsgrannhet kan kritiseras för att vara
opålitliga, sakna ambition och inte hålla sig inom ramarna, men de får
å andra sidan uppleva många kortvariga nöjen och kommer aldrig att
beskrivas som stela.`,
  results: [
    {
      score: 'low', // do not translate this line
      text: `Ditt resultat på Samvetsgrannhet är lågt, vilket tyder på att du vill
leva i nuet och göra det som känns bra just nu. Ditt arbete tenderar att
bli slarvigt och oorganiserat.`
    },
    {
      score: 'neutral', // do not translate this line
      text: `Ditt resultat på Samvetsgrannhet är genomsnittligt. Det innebär att
du är rimligt pålitlig, organiserad och självkontrollerad.`
    },
    {
      score: 'high', // do not translate this line
      text: `Ditt resultat på Samvetsgrannhet är högt. Det innebär att du sätter
tydliga mål och arbetar målmedvetet för att nå dem. Andra ser dig som
pålitlig och hårt arbetande.`
    }
  ],
  facets: [
    {
      facet: 1,
      title: 'Självtillit',
      text: `Självtillit beskriver tilltron till den egna förmågan
att åstadkomma saker. Personer med höga värden tror att de har den
intelligens (sunt förnuft), drivkraft och självkontroll som krävs för att
lyckas. Personer med låga värden känner sig inte lika effektiva och kan
uppleva att de inte har kontroll över sina liv.`
    },
    {
      facet: 2,
      title: 'Ordning',
      text: `Personer med höga värden på Ordning är välorganiserade.
De tycker om att leva enligt rutiner och scheman. De gör listor och
planer. Personer med låga värden tenderar att vara oorganiserade och
splittrade.`
    },
    {
      facet: 3,
      title: 'Plikttrogenhet',
      text: `Denna skala speglar styrkan i en persons känsla
av plikt och ansvar. De som får höga värden har en stark känsla av
moraliskt ansvar. Personer med låga värden upplever avtal, regler och
förordningar som alltför begränsande. De kan uppfattas som opålitliga
eller till och med ansvarslösa.`
    },
    {
      facet: 4,
      title: 'Prestationssträvan',
      text: `Personer med höga värden på denna skala
strävar hårt efter att uppnå excellens. Deras vilja att bli sedda som
framgångsrika håller dem på spåret mot höga mål. De har ofta en tydlig
riktning i livet, men extremt höga värden kan innebära att de blir alltför
ensidiga och fixerade vid arbete. Personer med låga värden är nöjda med
att klara sig med minsta möjliga ansträngning och kan av andra ses som
lata.`
    },
    {
      facet: 5,
      title: 'Självdisciplin',
      text: `Självdisciplin – det som många kallar
viljestyrka – handlar om förmågan att hålla ut i svåra eller obehagliga
uppgifter tills de är klara. Personer med höga värden har lättare att
övervinna motvilja och håller fast trots störningar. Personer med låga
värden skjuter ofta upp saker och har svårt att fullfölja, även uppgifter
de egentligen vill bli klara med.`
    },
    {
      facet: 6,
      title: 'Försiktighet',
      text: `Försiktighet beskriver benägenheten att tänka
igenom möjligheter innan man agerar. Personer med höga värden tar god
tid på sig när de fattar beslut. Personer med låga värden säger eller
gör ofta det första som kommer i åtanke utan att överväga alternativ och
deras troliga konsekvenser.`
    }
  ]
}

export const extraversion_sv: TemplateDomain = {
  domain: 'E',
  title: 'Extraversion',
  shortDescription: 'Extraversion kännetecknas av ett tydligt engagemang i den yttre världen.',
  description: `Extroverta personer tycker om att vara med andra, har mycket
energi och upplever ofta positiva känslor. De tenderar att vara
entusiastiska, handlingsinriktade individer som gärna säger ”Ja!” eller
”Nu kör vi!” när något spännande dyker upp. I grupper tycker de om att
prata, ta plats och dra uppmärksamhet till sig.
<br /><br />
Introverta personer saknar den utåtriktade energi- och aktivitetsnivån
som extroverta har. De tenderar att vara tystlåtna, lågmälda,
eftertänksamma och mer frånkopplade från det sociala livet. Deras
begränsade sociala engagemang ska inte tolkas som blyghet eller
depression; introverta behöver helt enkelt mindre stimulans än
extroverta och föredrar ofta att vara för sig själva.
<br /><br />
Introvertas självständighet och återhållsamhet misstas ibland för
ovänlighet eller arrogans. I verkligheten kommer en introvert person
med hög medgörlighet inte att aktivt söka upp andra, men kan vara mycket
trevlig när någon tar kontakt.`,
  results: [
    {
      score: 'low', // do not translate this line
      text: `Ditt resultat på Extraversion är lågt, vilket innebär att du är
introvert, reserverad och tystlåten. Du trivs i ensamhet och med
ensamma aktiviteter. När det gäller socialt umgänge begränsar du dig
ofta till några få nära vänner.`
    },
    {
      score: 'neutral', // do not translate this line
      text: `Ditt resultat på Extraversion är genomsnittligt, vilket innebär att du
varken är en tillbakadragen ensamvarg eller en ständigt pratglad
”glädjespridare”. Du uppskattar både tid med andra och tid för dig
själv.`
    },
    {
      score: 'high', // do not translate this line
      text: `Ditt resultat på Extraversion är högt, vilket innebär att du är
sällskaplig, utåtriktad, energisk och livlig. Du föredrar att vara i
närheten av andra människor större delen av tiden.`
    }
  ],
  facets: [
    {
      facet: 1,
      title: 'Vänlighet',
      text: `Vänliga personer tycker genuint om andra människor
och visar öppet positiva känslor gentemot dem. De får lätt nya vänner
och kan snabbt skapa nära och intima relationer. Personer med låga värden
är inte nödvändigtvis kalla eller fientliga, men de sträcker sig inte ut
på samma sätt och kan uppfattas som distanserade och reserverade.`
    },
    {
      facet: 2,
      title: 'Sällskaplighet',
      text: `Sällskapliga personer upplever andra människors
sällskap som stimulerande och belönande. De tycker om spänningen i
folksamlingar. Personer med lägre värden tenderar att känna sig
överväldigade av stora grupper och undviker dem därför aktivt. De ogillar
inte nödvändigtvis att vara med människor ibland, men deras behov av
integritet och tid för sig själva är mycket större än hos personer med
höga värden på denna skala.`
    },
    {
      facet: 3,
      title: 'Självhävdelse',
      text: `Personer som får höga värden på Självhävdelse
tycker om att ta ordet, ta kommandot och styra andras aktiviteter. De
tenderar att vara ledare i grupper. Personer med lägre värden pratar inte
lika mycket och låter i högre utsträckning andra styra vad gruppen gör.`
    },
    {
      facet: 4,
      title: 'Aktivitetsnivå',
      text: `Personer med hög aktivitetsnivå lever ett
snabbt och upptaget liv. De rör sig snabbt, energiskt och kraftfullt, och
är engagerade i många aktiviteter. Personer med lägre värden på denna
skala har ett långsammare, mer stillsamt och avslappnat tempo.`
    },
    {
      facet: 5,
      title: 'Spänningssökande',
      text: `Personer som får höga värden på denna skala
blir lätt uttråkade utan höga nivåer av stimulans. De älskar starka
intryck och mycket liv och rörelse. De är benägna att ta risker och
söka kickar. Personer med lägre värden blir lätt överväldigade av buller
och röra och undviker aktivt riskfyllda, ”kick-sökande” situationer.`
    },
    {
      facet: 6,
      title: 'Glädje',
      text: `Denna skala mäter positiva känslor och stämningsläge,
inte negativa känslor (som hör till domänen Neuroticism). Personer med
höga värden upplever ofta en rad positiva känslor, såsom lycka,
entusiasm, optimism och glädje. Personer med lägre värden är inte lika
benägna att uppleva denna typ av energisk, positiv sinnesstämning.`
    }
  ]
}

export const neuroticism_sv: TemplateDomain = {
  domain: 'N',
  title: 'Neuroticism',
  shortDescription: 'Neuroticism avser benägenheten att uppleva negativa känslor.',
  description: `Freud använde ursprungligen termen neuros för att beskriva ett
tillstånd präglat av psykiskt obehag, känslomässigt lidande och oförmåga
att hantera vardagens normala krav. Han menade att alla uppvisar vissa
tecken på neuros, men att vi skiljer oss åt i hur mycket vi lider och
vilka symtom vi har. Idag syftar Neuroticism på benägenheten att uppleva
negativa känslor. <br /><br />
Personer som får höga värden på Neuroticism kan främst uppleva en viss
typ av negativa känslor, såsom ångest, ilska eller nedstämdhet, men är
ofta benägna att uppleva flera av dessa känslotillstånd.
<br /><br />
Personer med höga värden på Neuroticism är känslomässigt reaktiva. De
reagerar starkt på händelser som inte skulle påverka de flesta människor
särskilt mycket, och deras reaktioner tenderar att bli mer intensiva än
normalt. De är mer benägna att tolka vardagliga situationer som hotfulla
och mindre frustrationer som hopplöst svåra.
<br /><br />
Deras negativa känslomässiga reaktioner tenderar att dröja sig kvar
ovanligt länge, vilket gör att de ofta är på dåligt humör. Dessa
svårigheter med känsloreglering kan försämra en neurotisk persons
förmåga att tänka klart, fatta beslut och hantera stress på ett effektivt
sätt.`,
  results: [
    {
      score: 'low', // do not translate this line
      text: `Ditt resultat på Neuroticism är lågt, vilket innebär att du är
ovanligt lugn, samlad och svår att rubba. Du reagerar inte med starka
känslor ens i situationer som de flesta skulle beskriva som stressande.`
    },
    {
      score: 'neutral', // do not translate this line
      text: `Ditt resultat på Neuroticism är genomsnittligt, vilket innebär att din
känslomässiga reaktivitet ligger nära befolkningens genomsnitt.
Stressande och frustrerande situationer är delvis påfrestande för dig,
men du har i allmänhet förmåga att komma över dessa känslor och hantera
situationerna.`
    },
    {
      score: 'high', // do not translate this line
      text: `Ditt resultat på Neuroticism är högt, vilket innebär att du lätt blir
upprörd, även av sådant som de flesta skulle betrakta som vardagliga
krav. Andra ser dig ofta som känslig och emotionell.`
    }
  ],
  facets: [
    {
      facet: 1,
      title: 'Ångest',
      text: `”Kamp- eller flykt”-systemet i hjärnan aktiveras
alltför lätt och ofta hos ångestbenägna individer. Därför känner personer
med höga värden på Ångest ofta att något farligt är på väg att hända.
De kan vara rädda för specifika situationer eller mer allmänt oroliga.
De känner sig spända, nervösa och uppskruvade. Personer med låga värden
är i allmänhet lugna och orädda.`
    },
    {
      facet: 2,
      title: 'Ilska',
      text: `Personer som får höga värden på Ilska känner stark irritation
och vrede när saker inte går deras väg. De är känsliga för orättvisor
och kan känna sig förbittrade och kränkta när de upplever att de blir
orättvist behandlade. Denna skala mäter benägenheten att känna ilska; om
personen faktiskt uttrycker irritation och fientlighet beror på nivån av
Medgörlighet. Personer med låga värden blir inte arga särskilt ofta eller
lätt.`
    },
    {
      facet: 3,
      title: 'Depressivitet',
      text: `Denna skala mäter benägenheten att känna sig ledsen,
nedstämd och uppgiven. Personer med höga värden saknar ofta energi och har
svårt att komma igång med aktiviteter. Personer med låga värden är i
mindre utsträckning drabbade av sådana depressiva känslor.`
    },
    {
      facet: 4,
      title: 'Självmedvetenhet',
      text: `Självmedvetna individer är känsliga för vad
andra tycker om dem. Deras oro för avvisande och förlöjligande gör att de
känner sig blyga och obekväma tillsammans med andra. De skäms lätt och
känner sig ofta skamsna. Deras rädsla för att bli kritiserade eller
utsatta för andras negativa omdömen är överdriven och orealistisk, men
deras stelhet och obehag kan göra att denna rädsla blir en
självuppfyllande profetia. Personer med låga värden lider inte av den
felaktiga föreställningen att alla tittar på och bedömer dem. De känner
sig inte nervösa i sociala situationer.`
    },
    {
      facet: 5,
      title: 'Omåttlighet',
      text: `Omåttliga individer upplever starka begär och
drifter som de har svårt att stå emot. De är mer inriktade på
kortsiktiga njutningar och belöningar än på långsiktiga konsekvenser.
Personer med låga värden upplever inte lika starka, oemotståndliga begär
och hamnar därför mer sällan i situationer där de tappar kontrollen eller överdriver.`
    },
    {
      facet: 6,
      title: 'Sårbarhet',
      text: `Personer med höga värden på Sårbarhet upplever
panik, förvirring och hjälplöshet när de utsätts för press eller stress.
Personer med låga värden känner sig mer samlade, trygga och klarsynta
under stress.`
    }
  ]
}

export const openness_sv: TemplateDomain = {
  domain: 'O',
  title: 'Öppenhet för erfarenhet',
  shortDescription: 'Öppenhet för erfarenhet beskriver en kognitiv stil som skiljer fantasifulla, kreativa personer från mer jordnära och konventionella personer.',
  description: `Öppna personer är intellektuellt nyfikna, uppskattar konst och är
känsliga för skönhet. Jämfört med mer slutna personer är de ofta mer
medvetna om sina känslor. De tenderar att tänka och agera på mer
individualistiska och okonventionella sätt. Intellektuella personer får
ofta höga värden på Öppenhet för erfarenhet; därför har denna faktor
ibland kallats Kultur eller Intellekt. <br /><br />
Intellektet är dock troligen bäst att se som en aspekt av Öppenhet för
erfarenhet. Resultat på Öppenhet hänger bara måttligt samman med antal
utbildningsår och resultat på traditionella intelligenstest.
<br /><br />
Ett annat kännetecken för en öppen kognitiv stil är förmågan att tänka
i symboler och abstraktioner långt bortom konkreta erfarenheter.
Beroende på individens specifika intellektuella förmågor kan denna
symboliska kognition ta formen av matematisk, logisk eller geometrisk
tanke, konstnärlig och metaforisk språkförmåga, musikskapande eller
musikframförande, eller någon av många visuella eller sceniska konstarter.
<br /><br />
Personer med låga värden på Öppenhet för erfarenhet tenderar att ha
snävare och mer allmänna intressen. De föredrar det enkla, raka och
tydliga framför det komplexa, tvetydiga och subtila. De kan se på
konst och vetenskap med skepsis och betrakta sådant som krångligt eller
opraktiskt. Slutna personer föredrar det välbekanta framför det nya; de
är mer konservativa och motståndskraftiga mot förändring.
<br /><br />
Öppenhet framställs ofta som mer hälsosamt eller moget av psykologer,
som själva ofta har hög Öppenhet för erfarenhet. Men både öppna och
slutna sätt att tänka kan vara funktionella i olika miljöer. Den
intellektuella stil som präglar öppna personer kan passa en professor
väl, men forskning har visat att en mer sluten stil hänger samman med
bättre arbetsprestation inom till exempel polisyrket, försäljning och
vissa serviceyrken.`,
  results: [
    {
      score: 'low', // do not translate this line
      text: `Ditt resultat på Öppenhet för erfarenhet är lågt, vilket innebär att du
tycker om att tänka i enkla och raka termer. Andra beskriver dig som
jordnära, praktisk och konservativ.`
    },
    {
      score: 'neutral', // do not translate this line
      text: `Ditt resultat på Öppenhet för erfarenhet är genomsnittligt, vilket
innebär att du uppskattar tradition men är villig att prova nya saker.
Ditt sätt att tänka är varken särskilt enkelt eller särskilt komplext.
För andra framstår du som en välutbildad person men inte nödvändigtvis
som intellektuell.`
    },
    {
      score: 'high', // do not translate this line
      text: `Ditt resultat på Öppenhet för erfarenhet är högt, vilket innebär att du
tycker om nyheter, variation och förändring. Du är nyfiken, fantasifull
och kreativ.`
    }
  ],
  facets: [
    {
      facet: 1,
      title: 'Fantasi',
      text: `För fantasirika individer är verkligheten ofta för
enkel och vardaglig. Personer med höga värden på denna skala använder
fantasin för att skapa en rikare och mer intressant värld. Personer med
lägre värden på denna skala är mer inriktade på fakta än på fantasi.`
    },
    {
      facet: 2,
      title: 'Estetiska intressen',
      text: `Personer med höga värden på denna skala älskar
skönhet, både i konst och i natur. De blir lätt engagerade och uppslukade
av estetiska och naturupplevelser. De är inte nödvändigtvis konstnärligt
utbildade eller talangfulla, även om många är det. Det som definierar
denna skala är intresset för och uppskattningen av naturlig och
skapad skönhet. Personer med lägre värden saknar i högre grad estetisk
känslighet och intresse för konst.`
    },
    {
      facet: 3,
      title: 'Känslomässighet',
      text: `Personer med höga värden på Känslomässighet har
god tillgång till och medvetenhet om sina egna känslor. Personer med
lägre värden är mindre medvetna om sina känslor och tenderar att inte
uttrycka dem öppet.`
    },
    {
      facet: 4,
      title: 'Äventyrslystnad',
      text: `Personer med höga värden på Äventyrslystnad är
ivria att prova nya aktiviteter, resa till nya platser och uppleva olika
saker. De tycker att det välbekanta och rutinmässiga är tråkigt och kan
till och med välja en annan väg hem bara för att den är annorlunda.
Personer med lägre värden känner sig ofta obekväma med förändring och
föredrar välbekanta rutiner.`
    },
    {
      facet: 5,
      title: 'Intellekt',
      text: `Intellekt och estetiska intressen är de två mest
centrala aspekterna av Öppenhet för erfarenhet. Personer med höga värden
på Intellekt tycker om att leka med idéer. De är öppna för nya och
ovanliga tankar och gillar att diskutera intellektuella frågor. De
uppskattar gåtor, pussel och hjärngympa. Personer med lägre värden
arbetar hellre med människor eller konkreta saker än med abstrakta idéer.
De betraktar intellektuella övningar som slöseri med tid. Intellekt ska
inte förväxlas med intelligens. Intellekt beskriver en intellektuell stil,
inte en intellektuell förmåga, även om personer med höga värden i
genomsnitt får något högre resultat på traditionella intelligenstest än
personer med låga värden.`
    },
    {
      facet: 6,
      title: 'Liberalism',
      text: `Psykologisk liberalism syftar på en beredskap att
utmana auktoriteter, konventioner och traditionella värderingar. I sin
mest extrema form kan psykologisk liberalism yttra sig som direkt
fientlighet mot regler, sympati för normbrytare och en dragning till
tvetydighet, kaos och oordning. Psykologiska konservativa föredrar den
trygghet och stabilitet som följer av att hålla sig till traditioner.
Psykologisk liberalism och konservatism är inte identiska med
partipolitiska åsikter, men de kan påverka vilka politiska partier en
person dras till.`
    }
  ]
}


